/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.triggerGeofence.internal

import features.triggerGeofence.models.TriggerGeofenceRequest
import features.triggerGeofence.models.TriggerGeofenceResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class TriggerGeofencesRequest : NetworkRequest() {

    suspend fun triggerGeofence(
        overrideHeaders: Map<String, String>? = null,
        triggerGeofenceRequest: TriggerGeofenceRequest
    ): IOResult<TriggerGeofenceResponseModel> {
        return safeNetworkCall {
            post<TriggerGeofenceResponseModel, TriggerGeofenceRequest>(
                endpoint = TriggerGeofencesEndpoint,
                requestBody = triggerGeofenceRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
